import type { SVGProps } from 'react';

const SvgKey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M9 19.982c-2.76 0-5-2.24-5-5 0-2.94 2.52-5.33 5.55-4.97l5.74-5.74a1 1 0 0 1 .71-.29h3c.55 0 1 .45 1 1v3c0 .27-.11.52-.29.71l-1 1a1 1 0 0 1-.71.29h-1v1c0 .55-.45 1-1 1h-1v1c0 .27-.11.52-.29.71l-.74.74A5 5 0 0 1 9 19.982m0-8c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3c0-.21-.03-.43-.08-.67-.08-.34.02-.69.27-.93l.81-.81v-1.59c0-.55.45-1 1-1h1v-1c0-.55.45-1 1-1h1.59l.41-.41v-1.59h-1.59l-5.81 5.81c-.24.24-.6.34-.93.27-.24-.06-.46-.08-.67-.08"
    />
    <path fill="currentcolor" d="M9 15.982a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
  </svg>
);
export default SvgKey;
